import FlashLib from 'flashlib_onlyplay';
import { orangeGradientFontStyle, shadowText } from '../../fontStyles';

export default class FreespinsContainer extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
    this.init()
  }
  init() {
    this.lableField = this.getChildByName('freespins_game_freespins');
    this.amountField = this.getChildByName('amount');
    this.setTextStyles();
  }
  setTextStyles() {
    this.lableField.style = { ...this.lableField.style, ...shadowText }
    this.amountField.style = { ...this.amountField.style, ...orangeGradientFontStyle }
  }
  setValue(value) {
    this.amountField.text = `${value}`;
  }
}
